/*
|--------------------------------------------------------------------------
| Views: Common
|--------------------------------------------------------------------------
*/
/**
 * Common functionality for all views that need it
 * @namespace
 */
 __gh__webApp.views.common = {
	"prepItemData": function(items){
		for (var i = 0; i < items.length; i++) {
		   items[i].isOpinion 		= (__gh__webApp.data.validate.item.isOpinion(items[i])) ? true : false;

		   //Related Content - Content
		   if((__gh__webApp.data.validate.item.hasRelatedContentContent(items[i]))){

			   // Has Gallery
			   var relHasGallery 	= __gh__webApp.data.itemValidator({"data":items[i].relatedContent.content.items,"required":1,"validationMethod":"isGallery"});
			   items[i].relatedContent.content.hasGallery = (relHasGallery===false) ? false : true;

			   // Has Story
			   var relHasStory		= __gh__webApp.data.itemValidator({"data":items[i].relatedContent.content.items,"required":1,"validationMethod":"isStory"});
			   items[i].relatedContent.content.hasStory = (relHasStory===false) ? false : true;

			   // Has Video
			   var relHasVideo 		= __gh__webApp.data.itemValidator({"data":items[i].relatedContent.content.items,"required":1,"validationMethod":"isVideo"});
			   items[i].relatedContent.content.hasVideo = (relHasVideo===false) ? false : true;

		   }
		}
		return items;
	},

	"splitItems": function(items,mainItemCount,bucket){
		var validateBucket			= __gh__webApp.data.validate.bucket,
			mainItems 				= items.slice(0,mainItemCount),
			mainItems				= this.prepItemData(mainItems);

		//Split up more headlines
		if (validateBucket.hasMoreHeadlines(bucket)){

			var moreHeadlineItems 	=  items.slice(mainItemCount,mainItemCount+9),
				moreHeadlines		= (moreHeadlineItems.length == 0) ? false : {
					"col1": moreHeadlineItems.slice(0,3),
					"col2": moreHeadlineItems.slice(3,6),
					"col3": moreHeadlineItems.slice(6,9)
				};

			if(validateBucket.hasMoreHeadlinesAd(bucket)){
				delete moreHeadlines.col3;
			}
		}

		return {"main":mainItems,"moreHeadlines":moreHeadlines};
	}


};
